import RMSOnboardingNotCompletedContainer from "./RMSOnboardingNotCompletedContainer";
import RMSOnboardingNotCompletedStore from "./RMSOnboardingNotCompletedStore";

export default RMSOnboardingNotCompletedStore(RMSOnboardingNotCompletedContainer);